import * as Sentry from '@sentry/react';
import * as z from 'zod';

import { createModuleLogger } from '#apps/client-web/app/utils/logger';

export const setup = async () => {
  const logger = createModuleLogger('bootstrap/sentry');
  logger.info('Initializing Sentry...');

  Sentry.init({
    dsn: z.url().parse(import.meta.env.APP_CLIENT_WEB_SENTRY_DSN),
    environment: z
      .string()
      .parse(import.meta.env.APP_CLIENT_WEB_SENTRY_ENVIRONMENT),

    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    attachStacktrace: true,
  });

  logger.info('Initialized successfully');
};

export default { setup };
